import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import React from "react";

export default class ErrorDialogue extends React.Component<{show: boolean, title: string, message: string, onClose: () => void}, {}> {

    render() {
        return (
            <Dialog
                    open={this.props.show}
                    onClose={() => this.setState({showErrorDialogue: false})}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {this.props.title}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {this.props.message}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() =>this.props.onClose()}>Ok</Button>
                </DialogActions>
            </Dialog>
        );
    }
}